import type { MediaImage } from '@/components/models';
import type { ProductComplete } from '@/features/Product/types/models';

export const createProductMapKey = (sku: string, handle: string): string => `${sku}@${handle}`;

export const isSkuVariantOfBase = (sku: string, baseSku: string): boolean =>
  sku === baseSku || sku.startsWith(`${baseSku}-`) || sku.startsWith(`${baseSku}_`);

export const matchesAnyBaseSku = (sku: string, baseSkus: string[]): boolean =>
  baseSkus.some((baseSku) => isSkuVariantOfBase(sku, baseSku));

export const getProductFeatureImage = (product: ProductComplete): MediaImage =>
  product.media.doubleWide ?? product.media.featureImage ?? product.media.cart;
